import { RootStore } from 'store/rootStore';
import { action, computed, makeObservable, observable } from 'mobx';
import { File } from 'types/policyService';
import {
  getAdditionalOutputsByPeriodId,
  getPolicyByEnrollmentPeriodId,
  getPreSignUrl,
} from 'api/operations/policyService';
import { downloadByUrl } from '@insurancemenu/imenu-components-lib/dist/helpers/downloadByUrl';

export default class AdditionalOutputsStore {
  rootStore: RootStore;
  outputPDFs: File[] = [];
  outputZip?: File = undefined;
  loading = true;
  isWarningModalOpen = false;

  public setLoading(status: boolean): void {
    this.loading = status;
  }

  public get creationDate(): string {
    return (this.outputPDFs.length > 0 && this.outputPDFs[0].creationDate) || '';
  }

  public async getInitialData(periodId: string): Promise<void> {
    this.resetFiles();
    this.setLoading(true);

    try {
      const results = await Promise.all([
        getAdditionalOutputsByPeriodId(periodId),
        getPolicyByEnrollmentPeriodId(periodId),
      ]);
      this.outputPDFs = results[0] || [];
      this.outputZip = results[1]?.additionalOutputsZip;
      if (this.outputPDFs.length === 0) {
        this.updateModalShowStatus(true);
      }
    } catch (error) {
      this.updateModalShowStatus(true);
    } finally {
      this.setLoading(false);
    }
  }

  public async downloadFinalZip(): Promise<void> {
    if (this.outputZip && this.outputZip.id) {
      const zipLink = await getPreSignUrl(this.outputZip.id);
      downloadByUrl(zipLink);
    }
  }

  public resetFiles(): void {
    this.setLoading(true);
    this.updateModalShowStatus(false);
    this.outputPDFs = [];
    this.outputZip = undefined;
  }

  updateModalShowStatus(showStatus: boolean): void {
    this.isWarningModalOpen = showStatus;
  }

  constructor(rootStore: RootStore) {
    this.rootStore = rootStore;
    makeObservable(this, {
      loading: observable,
      outputPDFs: observable,
      outputZip: observable,
      isWarningModalOpen: observable,
      creationDate: computed,
      getInitialData: action.bound,
      setLoading: action.bound,
      updateModalShowStatus: action.bound,
      downloadFinalZip: action.bound,
      resetFiles: action.bound,
    });
  }
}
